
      var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsCallPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 20,
  height: 20,
  viewBox: "0 0 20 20"
}, props), _image || (_image = /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAApVBMVEVMaXGBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqnVo2riAAAANnRSTlMArNjG+fP2/sX7vv3j6eD09aqt+PL6zujJmOyN6qmT78yvpM/C1cu1q8rNgt+21oC42oGZyIhv7aURAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAnUlEQVR42mWR1RLEIAxFszVq6+7ubvf/P21JuxUgD4fMgUnuDERE1RoZBdcRunPmRA3dglFX7QPpVa8s7b/0y7KSSE+YM6cYa/LCiFV55acHLFUbeBIWVtoAS2KLUG4VnUzukzwnTAboB1Fmj9hIzgQWRN083Bo7Pu6Mdm59jIoVrawbAnbandEsMtyA+E0UwlWifSLIehq/8H3x8QOiWA1EWiZPOQAAAABJRU5ErkJggg==",
  width: 20,
  height: 20,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAApVBMVEVMaXGBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqnVo2riAAAANnRSTlMArNjG+fP2/sX7vv3j6eD09aqt+PL6zujJmOyN6qmT78yvpM/C1cu1q8rNgt+21oC42oGZyIhv7aURAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAnUlEQVR42mWR1RLEIAxFszVq6+7ubvf/P21JuxUgD4fMgUnuDERE1RoZBdcRunPmRA3dglFX7QPpVa8s7b/0y7KSSE+YM6cYa/LCiFV55acHLFUbeBIWVtoAS2KLUG4VnUzukzwnTAboB1Fmj9hIzgQWRN083Bo7Pu6Mdm59jIoVrawbAnbandEsMtyA+E0UwlWifSLIehq/8H3x8QOiWA1EWiZPOQAAAABJRU5ErkJggg==",
  preserveAspectRatio: "none"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><defs></defs><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAApVBMVEVMaXGBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqnVo2riAAAANnRSTlMArNjG+fP2/sX7vv3j6eD09aqt+PL6zujJmOyN6qmT78yvpM/C1cu1q8rNgt+21oC42oGZyIhv7aURAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAnUlEQVR42mWR1RLEIAxFszVq6+7ubvf/P21JuxUgD4fMgUnuDERE1RoZBdcRunPmRA3dglFX7QPpVa8s7b/0y7KSSE+YM6cYa/LCiFV55acHLFUbeBIWVtoAS2KLUG4VnUzukzwnTAboB1Fmj9hIzgQWRN083Bo7Pu6Mdm59jIoVrawbAnbandEsMtyA+E0UwlWifSLIehq/8H3x8QOiWA1EWiZPOQAAAABJRU5ErkJggg==\" id=\"convert2-baked\" width=\"20\" height=\"20\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAApVBMVEVMaXGBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqmBDqnVo2riAAAANnRSTlMArNjG+fP2/sX7vv3j6eD09aqt+PL6zujJmOyN6qmT78yvpM/C1cu1q8rNgt+21oC42oGZyIhv7aURAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAnUlEQVR42mWR1RLEIAxFszVq6+7ubvf/P21JuxUgD4fMgUnuDERE1RoZBdcRunPmRA3dglFX7QPpVa8s7b/0y7KSSE+YM6cYa/LCiFV55acHLFUbeBIWVtoAS2KLUG4VnUzukzwnTAboB1Fmj9hIzgQWRN083Bo7Pu6Mdm59jIoVrawbAnbandEsMtyA+E0UwlWifSLIehq/8H3x8QOiWA1EWiZPOQAAAABJRU5ErkJggg==\" preserveAspectRatio=\"none\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-call-phone.df4b22e7f6d92ef9fe84d583f2bcbeba.svg"),
        {
          React: SvgIconsCallPhone,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      